import { useCallback, useRef } from "react";
import { formatDateKey, getPriceVariant } from "../../utils/fareCalendar.js";
export const useFareCalendarTracking = ({ flightsMap, isRoundTrip, startDate, endDate, fareCalendarEnabled, onTrackSBExperimentCustomGoal, onTrackSBExperimentGoalWithValue }) => {
    const previousEndDateRef = useRef(null);
    if (endDate && flightsMap) {
        const dateKey = formatDateKey(endDate);
        const flight = flightsMap[dateKey];
        const price = flight?.pricePerAdult?.value;
        if (price) {
            previousEndDateRef.current = { date: endDate, price };
        }
    }
    const trackFareCalendarGoals = useCallback((newStartDate, newEndDate) => {
        if (!flightsMap || !newStartDate)
            return;
        const shouldTrackDateClick = !isRoundTrip || newEndDate;
        if (shouldTrackDateClick && fareCalendarEnabled) {
            const dateToTrack = isRoundTrip && newEndDate ? newEndDate : newStartDate;
            const trackDateKey = formatDateKey(dateToTrack);
            const trackFlight = flightsMap[trackDateKey];
            if (trackFlight?.priceIndication) {
                const variant = getPriceVariant(trackFlight.priceIndication);
                const variantValue = variant === "good" ? 1 : variant === "neutral" ? 2 : 3;
                onTrackSBExperimentGoalWithValue?.({
                    name: "flights_web_cat_fare_calendar_oneway_date_click",
                    value: variantValue
                });
            }
        }
        let currentPrice;
        let newPrice;
        if (!isRoundTrip && startDate) {
            const currentDateKey = formatDateKey(startDate);
            const newDateKey = formatDateKey(newStartDate);
            const currentFlight = flightsMap[currentDateKey];
            const newFlight = flightsMap[newDateKey];
            currentPrice = currentFlight?.pricePerAdult?.value;
            newPrice = newFlight?.pricePerAdult?.value;
        }
        else if (isRoundTrip) {
            const startDateChanged = startDate && newStartDate && startDate.getTime() !== newStartDate.getTime();
            const endDateChanged = newEndDate &&
                previousEndDateRef.current &&
                previousEndDateRef.current.date.getTime() !== newEndDate.getTime();
            const isSelectingReturn = newEndDate && !startDateChanged;
            if (isSelectingReturn && endDateChanged && previousEndDateRef.current) {
                const newDateKey = formatDateKey(newEndDate);
                const newFlight = flightsMap[newDateKey];
                currentPrice = previousEndDateRef.current.price;
                newPrice = newFlight?.pricePerAdult?.value;
            }
            else if (startDateChanged && startDate) {
                const currentDateKey = formatDateKey(startDate);
                const newDateKey = formatDateKey(newStartDate);
                const currentFlight = flightsMap[currentDateKey];
                const newFlight = flightsMap[newDateKey];
                currentPrice = currentFlight?.pricePerAdult?.value;
                newPrice = newFlight?.pricePerAdult?.value;
            }
        }
        if (currentPrice && newPrice) {
            if (newPrice < currentPrice) {
                onTrackSBExperimentCustomGoal?.({ name: "flights_web_cat_fare_calendar_oneway", customGoal: 1 });
            }
            else {
                onTrackSBExperimentCustomGoal?.({ name: "flights_web_cat_fare_calendar_oneway", customGoal: 2 });
            }
        }
    }, [
        flightsMap,
        isRoundTrip,
        startDate,
        fareCalendarEnabled,
        onTrackSBExperimentCustomGoal,
        onTrackSBExperimentGoalWithValue
    ]);
    return { trackFareCalendarGoals };
};
